module.exports = __webpack_public_path__ + "static/media/cardQ.c37dc4ee.svg";